const STYLES = {
  "RICHIESTA RICEVUTA": "bg-amber-100 text-amber-800 border-amber-300",
  "IN LAVORAZIONE": "bg-sky-100 text-sky-800 border-sky-300",
  "APPROVATA": "bg-green-100 text-green-800 border-green-300",
  "COMPLETATA": "bg-bordeaux-ultralight text-bordeaux border-bordeaux-border",
  "ANNULLATA": "bg-red-100 text-red-800 border-red-300",
  "PAGAMENTO IN ATTESA": "bg-amber-100 text-amber-800 border-amber-300",
  "PAGAMENTO RICEVUTO": "bg-green-100 text-green-800 border-green-300",
  "PAGAMENTO VERIFICATO": "bg-bordeaux-ultralight text-bordeaux border-bordeaux-border",
  "PAGAMENTO NON VERIFICATO": "bg-red-100 text-red-800 border-red-300",
};

export default function StatusBadge({ stato }) {
  return (
    <span
      data-testid="request-status-badge"
      className={`inline-block rounded-full border px-3 py-1 text-xs font-semibold ${STYLES[stato] || "bg-muted text-foreground border-border"}`}
    >
      {stato}
    </span>
  );
}
